(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7678,4616],{

/***/ 67394:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Batch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Batch"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manualScrap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":144}}');
    doc.loc.source = JSON.parse('{"body":"fragment Batch on Batch {\\n  batchId\\n  batchNumber\\n  state\\n  amount\\n  manualScrap\\n  plannedStart\\n  actualStart\\n  actualStop\\n  comment\\n  lineId\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 96352:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Packaging"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Packaging"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagingNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":101}}');
    doc.loc.source = JSON.parse('{"body":"fragment Packaging on Packaging {\\n  packagingId\\n  lineId\\n  name\\n  packagingNumber\\n  unit\\n  comment\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 50619:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatedLineSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedAverageSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataMultiplier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":181}}');
    doc.loc.source = JSON.parse('{"body":"fragment Product on Product {\\n  productId\\n  name\\n  itemNumber\\n  lineId\\n  validatedLineSpeed\\n  expectedAverageSpeed\\n  dataMultiplier\\n  comment\\n  parameters {\\n    key\\n    value\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 71449:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SensorConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SensorConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"findStops"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"energyMeter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopRegisterThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopValueThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataMultiplier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogInputRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensorUnit"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"accumulatorConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetsOnPowerOff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolloverValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rolloverThreshold"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"discreteConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultState"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"validatedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publishRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sampleRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"triggerIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataAlarm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationFrequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateBuffer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"repeatNotification"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"chartTimeScale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataFilter"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":693}}');
    doc.loc.source = JSON.parse('{"body":"fragment SensorConfig on SensorConfig {\\n  type\\n  stopThreshold\\n  findStops\\n  energyMeter\\n  stopRegisterThreshold\\n  stopValueThreshold\\n  dataMultiplier\\n  validatedSpeed\\n  expectedSpeed\\n  analogOffset\\n  analogInputRange\\n  sensorUnit {\\n    unit\\n    label\\n  }\\n  accumulatorConfig {\\n    resetsOnPowerOff\\n    rolloverValue\\n    rolloverThreshold\\n  }\\n  discreteConfig {\\n    onStates\\n    offStates\\n    defaultState\\n  }\\n  validatedSpeed\\n  expectedSpeed\\n  publishRate\\n  sampleRate\\n  triggerIndex\\n  dataAlarm {\\n    subscribers {\\n      type\\n      value\\n      languageCode\\n    }\\n    notificationFrequency\\n    updateBuffer\\n    repeatNotification\\n  }\\n  chartTimeScale\\n  chart {\\n    scale\\n    dataFilter\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 16634:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopCause"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopCause"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"languageCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireInitials"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requireComment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enableCountermeasure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetSetup"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constantTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parameterTimes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parameter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unlessParameter"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":335}}');
    doc.loc.source = JSON.parse('{"body":"fragment StopCause on StopCause {\\n  _id\\n  id\\n  name\\n  description\\n  categoryName\\n  meta {\\n    name\\n    description\\n    languageCode\\n  }\\n  languageCode\\n  stopType\\n  requireInitials\\n  requireComment\\n  enableCountermeasure\\n  targetSetup {\\n    constantTime\\n    parameterTimes {\\n      parameter\\n      time\\n      unlessParameter\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 51844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"deviceMinimumData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"index"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"points"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"index"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sensor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"lineOverviewWithKPI","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"samples"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"points"},"value":{"kind":"Variable","name":{"kind":"Name","value":"points"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"batches"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Batch"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"produced"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packaging"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Packaging"},"directives":[]}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cause"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfigEnums"},"directives":[]}]}}],"loc":{"start":0,"end":1679}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/sensor-config-enums.gql\'\\n#import \'@/graphql/fragments/batch.gql\'\\n#import \'@/graphql/fragments/product.gql\'\\n#import \'@/graphql/fragments/packaging.gql\'\\n\\nquery deviceMinimumData($uuid: ID!, $index: ID!, $time: [Time!]!, $points: Int!) {\\n  device(uuid: $uuid) {\\n    _id\\n    owner\\n    peripheral(index: $index) {\\n      _id\\n      id\\n      peripheralId\\n      index\\n      name\\n      peripheralType\\n      description\\n      ... on Sensor {\\n        peripheralInformation {\\n          node {\\n            type\\n          }\\n          line {\\n            id\\n            name\\n          }\\n        }\\n        config {\\n          ...SensorConfig\\n        }\\n        time(time: $time) @connection(key: \\"lineOverviewWithKPI\\") {\\n          timeRange {\\n            from\\n            to\\n          }\\n          samples(points: $points) {\\n            data {\\n              count\\n              accValue\\n              minValue\\n              maxValue\\n            }\\n            timeRange {\\n              from\\n              to\\n            }\\n          }\\n          batches {\\n            nextToken\\n            items {\\n              ...Batch\\n              stats {\\n                data {\\n                  produced\\n                }\\n              }\\n              product {\\n                ...Product\\n                packaging {\\n                  ...Packaging\\n                }\\n              }\\n            }\\n          }\\n          stats {\\n            data {\\n              lineStatus {\\n                status\\n                duration\\n                cause\\n              }\\n            }\\n          }\\n        }\\n      }\\n    }\\n  }\\n  ...SensorConfigEnums\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(79696).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(67394).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(50619).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(96352).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceMinimumData = oneQuery(doc, "deviceMinimumData");
        


/***/ }),

/***/ 99731:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sensors",
      function () {
        return __webpack_require__(47778);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ overview_top_bar; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(96741);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(35422);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(15015);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(18335);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(34756);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+base@5.0.0-alpha.125_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/base/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(51285);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(73469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(96620);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+system@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react@17.0.2/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(39481);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-select@3.2.0_react-dom@17.0.2_react@17.0.2/node_modules/react-select/creatable/dist/react-select.browser.esm.js + 18 modules
var react_select_browser_esm = __webpack_require__(63554);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./components/bars/search-bar.tsx


























var styles = function(theme) {
    return {
        root: {
            flex: 1
        },
        input: {
            display: "flex",
            padding: 0,
            height: theme.spacing(5)
        },
        valueContainer: {
            display: "flex",
            flexWrap: "wrap",
            flex: 1,
            alignItems: "center",
            overflow: "hidden"
        },
        chip: {
            margin: "".concat(theme.spacing(0.5), " ").concat(theme.spacing(0.25))
        },
        chipFocused: {
            backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
        },
        noOptionsMessage: {
            padding: "".concat(theme.spacing(), "px ").concat(theme.spacing(2))
        },
        singleValue: {
            fontSize: 16
        },
        placeholder: {
            position: "absolute",
            left: 2,
            fontSize: 16
        },
        paper: {
            position: "absolute",
            zIndex: 1,
            marginTop: theme.spacing(),
            left: 0,
            right: 0
        },
        divider: {
            height: theme.spacing(2)
        }
    };
};
function NoOptionsMessage(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.noOptionsMessage
    }, props.innerProps), {
        children: props.children
    }));
}
function inputComponent(_param) {
    var inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "inputRef"
    ]);
    // NOTE: Order is important, InputBase sets ref to null, thus we ensure it's
    // value by setting ref after the spread.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: inputRef
    }));
}
function Control(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        variant: "filled",
        fullWidth: true,
        InputProps: {
            inputComponent: inputComponent,
            inputProps: (0,_object_spread/* default */.Z)({
                className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.input,
                inputRef: props.innerRef,
                children: props.children
            }, props.innerProps)
        }
    }, props.selectProps.textFieldProps));
}
function Option(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            minWidth: 0,
            padding: "5px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: props.innerRef,
            selected: props.isFocused,
            component: "div",
            style: {
                fontWeight: props.isSelected ? 500 : 400,
                width: "100%"
            }
        }, props.innerProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    flex: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: [
                    " ",
                    props.children,
                    " "
                ]
            })
        }))
    });
}
function Placeholder(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.placeholder
    }, props.innerProps), {
        children: props.children
    }));
}
function SingleValue(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.singleValue
    }, props.innerProps), {
        children: props.children
    }));
}
function ValueContainer(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.valueContainer,
        children: props.children
    });
}
function MultiValue(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        tabIndex: -1,
        label: props.children,
        className: (0,clsx_m["default"])((ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.chip, (0,_define_property/* default */.Z)({}, (ref1 = props.selectProps.classes) === null || ref1 === void 0 ? void 0 : ref1.chipFocused, props.isFocused)),
        onDelete: props.removeProps.onClick,
        deleteIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, (0,_object_spread/* default */.Z)({}, props.removeProps))
    });
}
function Menu(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        square: true,
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.paper
    }, props.innerProps), {
        children: props.children
    }));
}
var components = {
    Control: Control,
    Menu: Menu,
    MultiValue: MultiValue,
    NoOptionsMessage: NoOptionsMessage,
    Option: Option,
    Placeholder: Placeholder,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
};
var createOption = function(label) {
    return {
        label: label,
        value: {
            type: "string",
            value: label
        }
    };
};
var SearchBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SearchBar, _Component);
    var _super = (0,_create_super/* default */.Z)(SearchBar);
    function SearchBar() {
        (0,_class_call_check/* default */.Z)(this, SearchBar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            inputValue: ""
        };
        _this.formatLabel = function(val) {
            return "".concat(_this.props.t([
                "shared:searchFor"
            ], {
                defaultValue: "Search for"
            }), ' "').concat(val, '"');
        };
        _this.createOption = function(inputValue) {
            return _this.props.handleChange((0,_to_consumable_array/* default */.Z)(_this.props.value).concat([
                createOption(inputValue)
            ]));
        };
        _this.handleChange = function(val) {
            _this.props.handleChange(Array.isArray(val) ? val : val ? [
                val
            ] : []);
        };
        return _this;
    }
    var _proto = SearchBar.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, value = _props.value, theme = _props.theme, suggestions = _props.suggestions, t = _props.t;
        var selectStyles = {
            input: function(base) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                    color: theme.palette.text.primary,
                    "& input": {
                        font: "inherit"
                    }
                });
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                style: {
                                    marginRight: theme.spacing(),
                                    backgroundColor: "#269AE0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            style: {
                                flexGrow: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                                classes: classes,
                                styles: selectStyles,
                                textFieldProps: {
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                createOptionPosition: "first",
                                formatCreateLabel: this.formatLabel,
                                options: suggestions,
                                components: components,
                                value: value,
                                onCreateOption: this.createOption,
                                onChange: this.handleChange,
                                placeholder: "".concat(t([
                                    "shared:typeToSearch"
                                ], {
                                    defaultValue: "Type to search"
                                }), "..."),
                                isMulti: true,
                                isClearable: true
                            })
                        })
                    ]
                })
            })
        });
    };
    return SearchBar;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var search_bar = (enhance(SearchBar));

// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(35606);
;// CONCATENATED MODULE: ./components/bars/overview-top-bar.tsx









var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        root: {
            overflow: "visible",
            marginBottom: theme.spacing(),
            "@media print": {
                display: "none"
            }
        },
        content: {
            paddingBottom: theme.spacing(2)
        },
        divContainer: {
            display: "flex",
            width: "100%",
            flexWrap: "nowrap"
        },
        hideOnSMDown: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        hideOnMDup: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.up("md"), {
            display: "none"
        })
    };
});
var OverviewTopBar = function(param) {
    var suggestions = param.suggestions, search = param.search, children = param.children, totalCount = param.totalCount, page = param.page, pageSize = param.pageSize, handleSearchChange = param.handleSearchChange, handlePageChange = param.handlePageChange;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        elevation: 1,
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: classes.content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.divContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar, {
                            suggestions: suggestions,
                            value: search,
                            handleChange: handleSearchChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.hideOnSMDown,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                }),
                                children
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.hideOnMDup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        justifyContent: "space-between",
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: children
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var overview_top_bar = (OverviewTopBar);


/***/ }),

/***/ 60840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28066);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14724);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61978);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99109);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_1__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(2),
            backgroundColor: "#f7f7f7"
        },
        /* Styles applied to the action element. */ action: {
            flex: "0 0 auto",
            alignSelf: "center"
        },
        /* Styles applied to the content wrapper element. */ content: {
            flex: "1 1 auto"
        }
    };
});
var DialogHeader = function(_param) {
    var action = _param.action, title = _param.title, onClose = _param.onClose, _children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "action",
        "title",
        "onClose",
        "children"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: classes.content
            }, props), {
                children: title
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.action,
                children: [
                    action,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "closeDialog",
                        onClick: onClose,
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DialogHeader);


/***/ }),

/***/ 47131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nv": function() { return /* binding */ getNodeIcon; }
/* harmony export */ });
/* unused harmony exports CAMERA_ICON, EVENT_ICON, getNodeRingIconPath */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52108);






var CAMERA_ICON = (/* unused pure expression or super */ null && (Cctv));
var EVENT_ICON = (/* unused pure expression or super */ null && (VideoInputAntenna));
var getNodeIcon = function(className, type) {
    switch(type){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Main */ .Jq.Main:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/bottleneck.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Counter */ .Jq.Counter:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/counter.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Scrap */ .Jq.Scrap:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/scrap.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Camera */ .Jq.Camera:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/camera.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Event */ .Jq.Event:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/event.svg",
                className: className
            });
        default:
            _types__WEBPACK_IMPORTED_MODULE_3__/* .assertUnreachable */ .U(type);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/counter.svg",
                className: className
            });
    }
};
var getNodeRingIconPath = function(type) {
    var highlighted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ICON_PATH = "/images/";
    switch(type){
        case Schema.NodeType.Main:
            return highlighted ? "".concat(ICON_PATH, "bottleneck_ring_highlight.svg") : "".concat(ICON_PATH, "bottleneck_ring.svg");
        case Schema.NodeType.Counter:
            return highlighted ? "".concat(ICON_PATH, "counter_ring_highlight.svg") : "".concat(ICON_PATH, "counter_ring.svg");
        case Schema.NodeType.Scrap:
            return highlighted ? "".concat(ICON_PATH, "scrap_ring_highlight.svg") : "".concat(ICON_PATH, "scrap_ring.svg");
        case Schema.NodeType.Camera:
            return highlighted ? "".concat(ICON_PATH, "camera_ring_highlight.svg") : "".concat(ICON_PATH, "camera_ring.svg");
        case Schema.NodeType.Event:
            return highlighted ? "".concat(ICON_PATH, "event_ring_highlight.svg") : "".concat(ICON_PATH, "event_ring.svg");
        default:
            Types.assertUnreachable(type);
            return highlighted ? "".concat(ICON_PATH, "counter_ring_highlight.svg") : "".concat(ICON_PATH, "counter_ring.svg");
    }
};


/***/ }),

/***/ 50524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_DoNotDisturb__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16321);
/* harmony import */ var _mui_icons_material_SignalCellular0Bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71980);
/* harmony import */ var _mui_icons_material_SignalCellular1Bar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36277);
/* harmony import */ var _mui_icons_material_SignalCellular2Bar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78408);
/* harmony import */ var _mui_icons_material_SignalCellular3Bar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90313);
/* harmony import */ var _mui_icons_material_SignalCellular4Bar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43333);
/* harmony import */ var _mui_icons_material_SignalWifi0Bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86256);
/* harmony import */ var _mui_icons_material_SignalWifi1Bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90117);
/* harmony import */ var _mui_icons_material_SignalWifi2Bar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9561);
/* harmony import */ var _mui_icons_material_SignalWifi3Bar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1025);
/* harmony import */ var _mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80331);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15015);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8942);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82672);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5887);



















var styles = function(theme) {
    return {
        avatarGreen: {
            backgroundColor: "#59b78cff"
        },
        avatarWhite: {
            backgroundColor: "#fff"
        },
        avatarRed: {
            backgroundColor: "#ff7068ff"
        },
        iconWhite: {
            color: "white"
        },
        iconBlack: {
            color: theme.palette.primary.main
        }
    };
};
var SignalAvatar = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)(), 1), t = ref[0];
    var classes = props.classes, conn = props.conn, isUnclaimed = props.isUnclaimed;
    var type = "wifi";
    var strength = 4;
    var helperText = "";
    if (conn && conn.type) {
        type = conn.type;
    }
    if (conn && conn.strength !== undefined && conn.strength !== null) {
        strength = conn.strength;
    }
    var icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: classes.iconBlack
    });
    var colorClass = classes.avatarWhite;
    if (isUnclaimed) {
        icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_DoNotDisturb__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: classes.iconBlack
        });
        helperText = t([
            "shared:deviceArchived"
        ], {
            defaultValue: "Device archived"
        });
    } else if (type === "wifi") {
        helperText = t([
            "shared:wifiSignalStrength"
        ], {
            defaultValue: "WiFi signal strength"
        });
        switch(strength){
            case 0:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi0Bar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 1:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi1Bar__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 2:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi2Bar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 3:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi3Bar__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 4:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
        }
    } else if (type === "cellular") {
        helperText = t([
            "shared:celularSignalStrength"
        ], {
            defaultValue: "Celular signal strength"
        });
        switch(strength){
            case 0:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular0Bar__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    className: classes.iconWhite
                });
                colorClass = classes.avatarRed;
                break;
            case 1:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular1Bar__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 2:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular2Bar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 3:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular3Bar__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
            case 4:
                icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular4Bar__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    className: classes.iconBlack
                });
                break;
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        title: helperText,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__["default"])(colorClass, "hideInPercy"),
            children: icon
        })
    });
// return (
// <Tooltip
//   title={
//     <p>
//       {`Connection type: ${type}`}
//       <br />
//       {`Signal strength: ${strength + 1}/5`}
//     </p>
//   }>
//   <Avatar className={colorClass}>{icon}</Avatar>
// </Tooltip>
// );
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__/* .withStyles */ .D)(styles)(SignalAvatar));


/***/ }),

/***/ 35606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81666);
/* harmony import */ var _mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54936);
/* harmony import */ var _mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56646);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34375);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14724);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5887);


















var styles = function(theme) {
    var _obj;
    return {
        pagination: {
            alignItems: "center",
            marginLeft: "1em",
            display: "flex"
        },
        buttons: {
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center"
        },
        rowsLabel: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            whiteSpace: "nowrap"
        }, theme.typography.caption), (_obj = {
            paddingRight: theme.spacing(5)
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("md"), {
            paddingRight: "0"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "lineHeight", theme.spacing(5)), _obj)),
        button: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            color: "inherit",
            minWidth: theme.spacing(2),
            height: theme.spacing(5)
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        activeButton: {
            fontWeight: "bold",
            cursor: "default"
        },
        arrowButton: {
            transform: theme.direction === "rtl" ? "rotate(180deg)" : undefined
        }
    };
};
var PageButton = function(args) {
    var text = args.text, isActive = args.isActive, isDisabled = args.isDisabled, classes = args.classes, onClick = args.onClick;
    var _obj;
    var buttonClasses = (0,clsx__WEBPACK_IMPORTED_MODULE_7__["default"])((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.button, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.activeButton, isActive), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: buttonClasses,
        disabled: isDisabled,
        onClick: onClick,
        disableRipple: isActive,
        children: text
    });
};
var ellipsisSymbol = "…";
var Paginator = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Paginator, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Paginator);
    function Paginator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, Paginator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.setPage = function(desiredPage) {
            return function() {
                return _this.props.onCurrentPageChange(desiredPage);
            };
        };
        _this.renderPageButtons = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, classes = _props.classes;
            var pageButtons = [];
            var maxButtonCount = 3;
            var startPage = 1;
            var endPage = totalPages || 1;
            if (maxButtonCount < totalPages) {
                startPage = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .calculateStartPage */ .kw6)(currentPage + 1, maxButtonCount, totalPages);
                endPage = startPage + maxButtonCount - 1;
            }
            if (startPage > 1) {
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(1),
                    classes: classes,
                    onClick: _this.setPage(0)
                }, 1));
                if (startPage > 2) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisStart"));
                }
            }
            for(var page = startPage; page <= endPage; page += 1){
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(page),
                    isActive: page === currentPage + 1,
                    classes: classes,
                    onClick: _this.setPage(page - 1),
                    isDisabled: startPage === endPage
                }, page));
            }
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisEnd"));
                }
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(totalPages),
                    classes: classes,
                    onClick: _this.setPage(totalPages - 1)
                }, totalPages));
            }
            return pageButtons;
        };
        _this.previousPage = function() {
            var _props = _this.props, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage > 0 && onCurrentPageChange(currentPage - 1);
        };
        _this.nextPage = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage < totalPages - 1 && onCurrentPageChange(currentPage + 1);
        };
        return _this;
    }
    var _proto = Paginator.prototype;
    _proto.render = function render() {
        var _props = this.props, totalPages = _props.totalPages, totalCount = _props.totalCount, pageSize = _props.pageSize, currentPage = _props.currentPage, classes = _props.classes, t = _props.t;
        var from = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .firstRowOnPage */ .dF$)(currentPage, pageSize, totalCount);
        var to = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .lastRowOnPage */ .ZN$)(currentPage, pageSize, totalCount);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.pagination,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classes.rowsLabel,
                    children: "".concat(from).concat(from < to ? "-".concat(to) : "", " ").concat(t([
                        "shared:pageOf"
                    ], {
                        defaultValue: "of"
                    }), " ").concat(totalCount)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                    container: true,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === 0,
                            onClick: this.previousPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
                        }),
                        this.renderPageButtons(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === totalPages - 1 || totalCount === 0,
                            onClick: this.nextPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            ]
        });
    };
    return Paginator;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .withTranslation */ .Z)([
    "shared"
]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__/* .withStyles */ .D)(styles, {
    name: "Paginator"
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Paginator));


/***/ }),

/***/ 15608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ millisAsmmss; },
/* harmony export */   "HN": function() { return /* binding */ localDayWithTimezoneOffset; },
/* harmony export */   "KB": function() { return /* binding */ convertPcsPerTimeToWantedUnit; },
/* harmony export */   "MI": function() { return /* binding */ timeFormatVariable; },
/* harmony export */   "Ob": function() { return /* binding */ timeFormatyyyyMMMddhhmmsstimezone; },
/* harmony export */   "Ox": function() { return /* binding */ timeFormatdMMMMhmm; },
/* harmony export */   "Ud": function() { return /* binding */ guardedCallbackString; },
/* harmony export */   "_D": function() { return /* binding */ evaluateWeekSpan; },
/* harmony export */   "_t": function() { return /* binding */ isBrowserLocale24h; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "j0": function() { return /* binding */ toHHMMSS; },
/* harmony export */   "l8": function() { return /* binding */ DateTimeLabelFormatBasedOnBrowserLocale; },
/* harmony export */   "mc": function() { return /* binding */ xDateFormatBasedOnBrowserLocale; },
/* harmony export */   "rr": function() { return /* binding */ timeFormatyyyyMMdd; },
/* harmony export */   "tI": function() { return /* binding */ timeFormatdMMMMyyyyhhmm; },
/* harmony export */   "td": function() { return /* binding */ timeFormatyyyyMMdhmm; },
/* harmony export */   "vw": function() { return /* binding */ guardedCallback; },
/* harmony export */   "wQ": function() { return /* binding */ mod; },
/* harmony export */   "xQ": function() { return /* binding */ excelReadableDateFormat; },
/* harmony export */   "zs": function() { return /* binding */ timeFormatyyyyMMdhmmss; }
/* harmony export */ });
/* unused harmony exports guardedCallbackNumber, timeFormatyyyyMMMMdhmmss, isNewFeature */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99758);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31650);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30489);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22638);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25955);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52108);





// TODO: Drop the use of this function, it's too simple to keep :p Excel does
// the formatting for us.
var excelReadableDateFormat = function(date) {
    if (!date) {
        return "";
    }
    return new Date(date);
};
var localDayWithTimezoneOffset = function(date) {
    var localDay = new Date(date.getTime() - date.getTimezoneOffset() * 1..minutes);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(localDay.toISOString().split("T"), 1), calendarDay = ref[0];
    return calendarDay;
};
var guardedCallbackNumber = function(callback) {
    return function(param) {
        var value = param.target.value;
        var parsedValue = Number(value);
        if (Number.isNaN(parsedValue)) {
            return;
        }
        return callback(parsedValue);
    };
};
var guardedCallbackString = function(callback) {
    return function(param) {
        var value = param.target.value;
        if (typeof value !== "string") {
            return;
        }
        return callback(value);
    };
};
var guardedCallback = guardedCallbackString;
var mod = function(n, m) {
    return (n % m + m) % m;
};
/**
 * Time Formatting 7/3/2021 13:00 or 3/7/2021 1:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
function millisAsmmss(ms) {
    var minutes = Math.floor(ms / (60 * 1000));
    var minutesms = ms % (60 * 1000);
    var sec = Math.floor(minutesms / 1000);
    return "".concat(minutes.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }), ":").concat(sec.toLocaleString(undefined, {
        minimumIntegerDigits: 2
    }));
}
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 13:00 or March 7, 1:00 PM
 * @param time
 */ var timeFormatdMMMMhmm = function(time, locale) {
    var genericTimeFormat = {
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7. marts 2021 13:00 or March 7, 2021, 1:00 PM
 * @param time
 */ var timeFormatdMMMMyyyyhhmm = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 or 3/7/2021
 * @param time
 */ var timeFormatyyyyMMdd = function(time, locale) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(time, Date) === false || isNaN(time.getTime())) {
        console.error("!Error: Parameter time was not an instane of date!");
        return "Invalid Date!";
    }
    var genericTimeFormat = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting 7/3/2021 13:00:00 or 3/7/2021 1:00:00 PM
 * @param time
 */ var timeFormatyyyyMMMMdhmmss = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        weekday: "long",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    };
    return intlFormat(time, genericTimeFormat, {
        locale: locale
    });
};
/**
 * Time Formatting:
 * Wed, 7. Mar, 2021, 13:00:00 Central European Standard time
 * or
 * Wed, Mar 7, 2021, 1:00:00 PM Central European Standard time
 * @param time
 */ var timeFormatyyyyMMMddhhmmsstimezone = function(time, locale) {
    var genericTimeFormat = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "long"
    };
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(time, genericTimeFormat, {
        locale: locale
    });
};
var isBrowserLocale24hCache = {};
/**
 * return true if locale in browser is 24h format
 */ var isBrowserLocale24h = function(language) {
    if (isBrowserLocale24hCache.hasOwnProperty(language)) {
        return isBrowserLocale24hCache[language];
    } else {
        var res = !new Intl.DateTimeFormat(language || navigator.language, {
            hour: "numeric"
        }).format(0).match(/AM|PM/);
        isBrowserLocale24hCache[language] = res;
        return res;
    }
};
/**
 * Time Formatting Monday, 15. Mar, 2021 - 13:00:00.000 or Monday, Mar 15, 2021 - 01:00:00.000 PM
 */ var xDateFormatBasedOnBrowserLocale = function(language) {
    if (isBrowserLocale24h(language)) {
        return "%A, %b %e, %Y - %H:%M:%S.%L";
    }
    return "%A, %e. %b, %Y - %I:%M:%S.%L%p";
};
/**
 * Time Formatting adds AM/PM formatting if browser locale is AM/PM
 */ var DateTimeLabelFormatBasedOnBrowserLocale = function(language) {
    var formats = {};
    if (isBrowserLocale24h(language)) {
        formats = {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%e. %b",
            week: "%e. %b",
            month: "%e. %b",
            year: "%b"
        };
    } else {
        formats = {
            millisecond: "%I:%M:%S.%L%p",
            second: "%I:%M:%S%p",
            minute: "%I:%M%p",
            hour: "%I:%M%p",
            day: "%b %e",
            week: "%b %e",
            month: "%b %e",
            year: "%b"
        };
    }
    return formats;
};
/**
 * Note: Format this way, instead of using date-fns, because date-fns format is timezone aware,
 * resulting in format(0, 'HH:mm:ss') = '01:00:00' for GMT+1.
 */ var toHHMMSS = function(v) {
    var secNum = Math.abs(Math.floor(v / 1000));
    var hours = Math.floor(secNum / 3600);
    var minutes = Math.floor((secNum - hours * 3600) / 60);
    var seconds = secNum - hours * 3600 - minutes * 60;
    hours = hours === 0 || isNaN(hours) ? "00" : (hours < 10 ? "0" : "") + "".concat(hours);
    minutes = minutes === 0 || isNaN(minutes) ? "00" : (minutes < 10 ? "0" : "") + "".concat(minutes);
    seconds = seconds === 0 || isNaN(seconds) ? "00" : (seconds < 10 ? "0" : "") + "".concat(seconds);
    var fs = hours + ":" + minutes + ":" + seconds;
    return v < 0 ? "-".concat(fs) : "".concat(fs);
};
/**
 * if i=14 it returns 14:00 or 2:00 PM depending on browser locale
 * @param i
 */ var timeFormatVariable = function(i, language) {
    if (isBrowserLocale24h(language)) {
        return i + ":00";
    } else {
        var timeString = "";
        if (i % 12 !== 0) {
            timeString = (i % 12).toString();
        } else {
            timeString = 12..toString();
        }
        if (i > 11) {
            timeString = timeString + ":00 PM";
        } else {
            timeString = timeString + ":00 AM";
        }
        return timeString;
    }
};
/**
 * turns number of pcs per time into wanted time unit (min/hour/day)
 */ var convertPcsPerTimeToWantedUnit = function(noOfPcs, currentUnit, wantedUnit) {
    var pcsPerMin = 0;
    //Convert pcs/currentUnit into pcs/min
    switch(currentUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerMin = noOfPcs / 60 / 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerMin = noOfPcs / 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerMin = noOfPcs;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(currentUnit);
            break;
    }
    //Convert pcs/min into pcs/wantedUnit
    var pcsPerWantedUnit = 0;
    switch(wantedUnit){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.DAY */ .cW.DAY:
            pcsPerWantedUnit = pcsPerMin * 60 * 24;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            pcsPerWantedUnit = pcsPerMin * 60;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_3__/* .ChartTimeScale.MINUTE */ .cW.MINUTE:
            pcsPerWantedUnit = pcsPerMin;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_4__/* .assertUnreachable */ .U(wantedUnit);
            break;
    }
    return pcsPerWantedUnit;
};
var isNewFeature = function(releaseTime) {
    var age = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7..days;
    return Date.now() <= new Date(releaseTime).getTime() + age;
};
function sleep(milliseconds) {
    return new Promise(function(r) {
        return setTimeout(r, milliseconds);
    });
}
var evaluateWeekSpan = function(date) {
    var dateCopy = new Date(date);
    dateCopy.setHours(0, 0, 0, 0);
    var monday = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(dateCopy, 1);
    var mondayNextWeek = (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(monday);
    return [
        monday,
        mondayNextWeek
    ];
};


/***/ }),

/***/ 98156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ withIAM; },
/* harmony export */   "y": function() { return /* binding */ withIAMPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59843);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_CardActions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98021);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24267);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34375);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89879);
/* harmony import */ var _contexts_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46036);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5887);
/* harmony import */ var _lib_features__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53541);




















// FIXME: Correct the user context signature...
// tslint:disable:max-classes-per-file
var withIAM = function(WrappedComponent) {
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMWrapper, _Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMWrapper);
        function WithIAMWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithIAMWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                children: function(user) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        user: user,
                        features: user.features,
                        hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                        hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                        hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                        hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                        hasFeatureInAnyUserPool: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features)
                    }, _this.props));
                }
            });
        };
        return WithIAMWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
};
var styles = function(theme) {
    return {
        card: {
            width: "100%",
            maxWidth: "500px"
        },
        fillHeight: {
            height: "100%"
        },
        title: {
            marginBottom: theme.spacing(2)
        }
    };
};
var withIAMPage = function(lookupFeatures, featureType) {
    var scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "group";
    return function(WrappedComponent) {
        var WithIAMPageWrapper = /*#__PURE__*/ function(_Component) {
            "use strict";
            (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMPageWrapper, _Component);
            var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMPageWrapper);
            function WithIAMPageWrapper() {
                (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMPageWrapper);
                return _super.apply(this, arguments);
            }
            var _proto = WithIAMPageWrapper.prototype;
            _proto.render = function render() {
                var _props = this.props, classes = _props.classes, t = _props.t, i18n = _props.i18n, tReady = _props.tReady, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_props, [
                    "classes",
                    "t",
                    "i18n",
                    "tReady"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                    children: function(_param) {
                        var status = _param.status, user = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
                            "status"
                        ]);
                        var allowed = scope === "userPool" ? _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features)(lookupFeatures, featureType) : _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features)(lookupFeatures, featureType);
                        var wrappedMessage;
                        if (!status.loading && user && user.features && !allowed) {
                            wrappedMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                className: classes.fillHeight,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                    container: true,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    className: classes.fillHeight,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            className: classes.card,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                            variant: "h5",
                                                            className: classes.title,
                                                            children: t([
                                                                "shared:unfortunatelyNoPermission"
                                                            ], {
                                                                defaultValue: "Unfortunately, you don't have permission to view this page!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                            children: t([
                                                                "shared:contactYourLocalAdminIfWrong"
                                                            ], {
                                                                defaultValue: "If you believe this is a mistake, contact your local administrator, and they can grant you access."
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardActions__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                        href: {
                                                            pathname: "/"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                            color: "primary",
                                                            children: t([
                                                                "shared:returnToFrontPage"
                                                            ], {
                                                                defaultValue: "Return to front page"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            });
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            loading: status.loading,
                            error: status.error,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                features: user.features,
                                hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                                hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                                hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                                hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features)
                            }, restProps))
                        });
                    }
                });
            };
            return WithIAMPageWrapper;
        }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
        var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_18__/* .withTranslation */ .Z)([
            "shared"
        ]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_19__/* .withStyles */ .D)(styles));
        return enhance(WithIAMPageWrapper);
    };
};


/***/ }),

/***/ 81861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ withUtils; },
/* harmony export */   "n": function() { return /* binding */ useUtils; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14478);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54765);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18151);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28879);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84984);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25655);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68568);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84358);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36712);







var additionalUtils = function(locale) {
    return {
        formatDistance: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatDistanceStrict: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatRelative: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatWeekdays: function(formatString) {
            var now = new Date();
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                start: (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                }),
                end: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                })
            }).map(function(day) {
                return (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(day, formatString, {
                    locale: locale
                });
            });
        }
    };
};
var useUtils = function() {
    var utils = new _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    return Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")));
};
var withUtils = function(WrappedComponent) {
    return function(props) {
        var utils = useUtils();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            utils: Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")))
        }));
    };
};


/***/ }),

/***/ 34614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ updateDataHash; },
/* harmony export */   "u": function() { return /* binding */ hashCode; }
/* harmony export */ });
var hashCode = function(s) {
    var hash = 0;
    if (!(s === null || s === void 0 ? void 0 : s.length)) {
        return String(hash);
    }
    for(var i = 0; i < s.length; i++){
        var char = s.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + char;
        // eslint-disable-next-line no-bitwise
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash);
};
var updateDataHash = function(setDataHash) {
    return function(data) {
        if (data) {
            var hash = hashCode(JSON.stringify(data));
            setDataHash(hash);
        }
    };
};


/***/ }),

/***/ 47778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ sensors; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(90918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(88802);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(54524);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(66637);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(25955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(85466);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(13515);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(25998);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(89879);
// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(35606);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(61431);
// EXTERNAL MODULE: ./graphql/queries/device-minimum-data.gql
var device_minimum_data = __webpack_require__(51844);
var device_minimum_data_default = /*#__PURE__*/__webpack_require__.n(device_minimum_data);
// EXTERNAL MODULE: ./graphql/queries/devices-simple.gql
var devices_simple = __webpack_require__(50936);
var devices_simple_default = /*#__PURE__*/__webpack_require__.n(devices_simple);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(74782);
// EXTERNAL MODULE: ./lib/hash.ts
var hash = __webpack_require__(34614);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(52108);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(6435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/MoreVert.js
var MoreVert = __webpack_require__(72748);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/SettingsSharp.js
var SettingsSharp = __webpack_require__(96487);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(98230);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(14724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(18691);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(3192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(34756);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(44143);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ./components/containers/highcharts.tsx
var highcharts = __webpack_require__(75805);
// EXTERNAL MODULE: ./components/icons/node-icon.tsx
var node_icon = __webpack_require__(47131);
// EXTERNAL MODULE: ./components/icons/signal-avatar.tsx
var signal_avatar = __webpack_require__(50524);
// EXTERNAL MODULE: ./lib/highcharts/data-config.ts + 2 modules
var data_config = __webpack_require__(8411);
// EXTERNAL MODULE: ./lib/highcharts/manual-process-config.ts
var manual_process_config = __webpack_require__(80946);
// EXTERNAL MODULE: ./views/dialogs/sensor-settings/sensor-settings-dialog.tsx + 14 modules
var sensor_settings_dialog = __webpack_require__(11818);
;// CONCATENATED MODULE: ./views/sensors/device-overview-card.tsx

























var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        card: {
            minHeight: "100%",
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        actions: {
            paddingLeft: theme.spacing(),
            paddingBottom: theme.spacing(),
            display: "flex",
            justifyContent: "space-around"
        },
        button: {
            margin: theme.spacing()
        },
        nodeIcon: {
            height: 25,
            width: 25,
            marginRight: theme.spacing(),
            marginBottom: theme.spacing(-1)
        },
        menu: {},
        menuItemStyles: {
            padding: theme.spacing(),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        menuItemIcon: {
            minWidth: theme.spacing(4)
        }
    };
});
var DeviceOverviewCard = function(param) {
    var device = param.device, sensor = param.sensor, loading = param.loading, refetchQueries = param.refetchQueries, dataHash = param.dataHash;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)([
        "shared",
        "device"
    ]), 2), t = ref8[0], i18n = ref8[1];
    var classes = useStyles().classes;
    var theme = (0,useTheme/* default */.Z)();
    var ref9 = (0,react.useState)(false), settingsDialogOpen = ref9[0], setSettingsDialogOpen = ref9[1];
    var ref10 = (0,react.useState)(null), menuAnchorEl = ref10[0], setMenuAnchorEl = ref10[1];
    var openMenu = Boolean(menuAnchorEl);
    var uuid = device.uuid;
    var index = sensor.index, name = sensor.name, description = sensor.description, config = sensor.config;
    var ref11;
    var nodeType = (ref11 = sensor === null || sensor === void 0 ? void 0 : (ref = sensor.peripheralInformation) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.type) !== null && ref11 !== void 0 ? ref11 : undefined;
    var ref12;
    var strength = ((ref12 = sensor === null || sensor === void 0 ? void 0 : (ref2 = sensor.time) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.stats) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.lineStatus) === null || ref6 === void 0 ? void 0 : ref6.status) !== null && ref12 !== void 0 ? ref12 : schema/* Status.OFF */.qb.OFF) === schema/* Status.OFF */.qb.OFF ? 0 : 4;
    var buttons = [
        {
            label: t([
                "shared:registerStops"
            ], {
                defaultValue: "Register Stops"
            }),
            uri: "register-stops"
        },
        {
            label: t([
                "shared:analytics"
            ], {
                defaultValue: "Analytics"
            }),
            uri: "analytics"
        }, 
    ];
    var isEnergyMeter = sensor.config.energyMeter === true;
    var openSettings = function(e) {
        setMenuAnchorEl(null);
        setSettingsDialogOpen(true);
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 12,
        md: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                className: classes.card,
                elevation: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_link/* ImperceptibleLink */.ah, {
                    href: {
                        pathname: "/sensor",
                        query: {
                            peripheralId: "".concat(uuid, "-").concat(index),
                            tab: "live"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "rtl-direction",
                            style: {
                                display: "flex",
                                padding: "16px 24px 16px 24px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        flex: "1 1 auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body1",
                                            children: [
                                                nodeType ? (0,node_icon/* getNodeIcon */.nv)(classes.nodeIcon, nodeType) : null,
                                                name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "textSecondary",
                                            variant: "body2",
                                            children: description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        flex: "0 0 auto",
                                        marginLeft: "15px",
                                        width: "40px",
                                        height: "40px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signal_avatar/* default */.Z, {
                                        conn: {
                                            strength: strength,
                                            type: "wifi"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        flex: "0 0 auto",
                                        marginLeft: "5px",
                                        width: "40px",
                                        height: "40px"
                                    },
                                    children: [
                                        isEnergyMeter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            className: classes.menu,
                                            "aria-label": "Settings",
                                            onClick: openSettings,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsSharp/* default */.Z, {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            className: classes.menu,
                                            "aria-label": "More",
                                            "aria-owns": openMenu ? "long-menu" : undefined,
                                            "aria-haspopup": "true",
                                            onClick: function(e) {
                                                setMenuAnchorEl(e.currentTarget);
                                                e.stopPropagation();
                                                e.preventDefault();
                                            },
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                            id: "long-menu",
                                            anchorEl: menuAnchorEl,
                                            open: openMenu,
                                            onClose: function(e) {
                                                setMenuAnchorEl(null);
                                                // These functions exist even if TS doesn't think so
                                                e.stopPropagation();
                                                e.preventDefault();
                                            },
                                            PaperProps: {
                                                style: {}
                                            },
                                            children: [
                                                config && config.type === "MEASUREMENT" ? null : buttons.map(function(btn) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                                                        href: {
                                                            pathname: "/sensor",
                                                            query: {
                                                                peripheralId: "".concat(uuid, "-").concat(index),
                                                                tab: btn.uri
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                            selected: false,
                                                            children: btn.label
                                                        }, btn.uri)
                                                    }, btn.uri);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                    variant: "middle"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                    selected: false,
                                                    onClick: openSettings,
                                                    className: classes.menuItemStyles,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                            className: classes.menuItemIcon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsSharp/* default */.Z, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "inherit",
                                                            noWrap: true,
                                                            children: t([
                                                                "sensor:sensorSettings"
                                                            ], {
                                                                defaultValue: "Sensor settings"
                                                            })
                                                        })
                                                    ]
                                                }, "sensorSettings")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                            className: "hideInPercy",
                            style: {
                                paddingBottom: 0
                            },
                            children: (sensor === null || sensor === void 0 ? void 0 : (ref7 = sensor.config) === null || ref7 === void 0 ? void 0 : ref7.type) !== schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS ? /*#__PURE__*/ (0,jsx_runtime.jsx)(highcharts/* Graph */.k, {
                                compareForUpdate: dataHash,
                                configOptions: {
                                    theme: theme,
                                    t: t,
                                    language: i18n.language,
                                    height: "180px",
                                    sensors: [
                                        sensor
                                    ],
                                    disableTooltip: true,
                                    disableExportMenu: true,
                                    showLegend: false
                                },
                                configFn: data_config/* default */.ZP,
                                loading: loading
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(highcharts/* Graph */.k, {
                                compareForUpdate: dataHash,
                                configOptions: {
                                    theme: theme,
                                    chartHeight: "180px",
                                    data: sensor,
                                    showLegend: false
                                },
                                configFn: manual_process_config/* default */.Z,
                                loading: loading
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sensor_settings_dialog/* default */.Z, {
                handleDialogChange: function() {
                    setMenuAnchorEl(null);
                    setSettingsDialogOpen(false);
                },
                dialogOpen: settingsDialogOpen,
                peripheralId: sensor.peripheralId,
                refetchQueries: refetchQueries
            })
        ]
    });
};
/* harmony default export */ var device_overview_card = (DeviceOverviewCard);

// EXTERNAL MODULE: ./components/bars/overview-top-bar.tsx + 1 modules
var overview_top_bar = __webpack_require__(19536);
;// CONCATENATED MODULE: ./views/sensors/overview-top-bar.tsx






var DevicesTopBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DevicesTopBar, _Component);
    var _super = (0,_create_super/* default */.Z)(DevicesTopBar);
    function DevicesTopBar() {
        (0,_class_call_check/* default */.Z)(this, DevicesTopBar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.generateSuggestions = function() {
            var filteredPeripherals = _this.props.filteredPeripherals;
            // Store all the suggestions in a map, to avoid duplicates.
            var suggestions = {};
            filteredPeripherals.forEach(function(peripheral) {
                // If we haven't started searching yet, include all results.
                if (!_this.props.search.length) {
                    var name = peripheral.name.toLowerCase();
                    if (name) {
                        suggestions[name] = {
                            label: peripheral.name,
                            value: {
                                type: "string",
                                value: name
                            }
                        };
                    }
                    var description = peripheral.description.toLowerCase();
                    if (description) {
                        suggestions[description] = {
                            label: peripheral.description,
                            value: {
                                type: "string",
                                value: description
                            }
                        };
                    }
                    var peripheralId = peripheral.peripheralId;
                    if (peripheralId) {
                        var lowerCasedPeripheralId = peripheralId.toLowerCase();
                        suggestions[lowerCasedPeripheralId] = {
                            label: peripheralId,
                            value: {
                                type: "string",
                                value: lowerCasedPeripheralId
                            }
                        };
                    }
                } else {
                    // Filter out both results and remaining suggestions, based on the search filter.
                    var foundInSearch = false;
                    _this.props.search.map(function(searchTerm) {
                        if (searchTerm && searchTerm.value && searchTerm.value.value) {
                            var name = peripheral.name.toLowerCase();
                            var description = peripheral.description.toLowerCase();
                            var peripheralId = peripheral.peripheralId;
                            var searchTermValue = searchTerm.value.value.toLowerCase();
                            foundInSearch = name.includes(searchTermValue) || description.includes(searchTermValue) || (peripheralId === null || peripheralId === void 0 ? void 0 : peripheralId.includes(searchTermValue));
                            if (foundInSearch) {
                                suggestions[name] = {
                                    label: peripheral.name,
                                    value: {
                                        type: "string",
                                        value: name
                                    }
                                };
                                suggestions[description] = {
                                    label: peripheral.description,
                                    value: {
                                        type: "string",
                                        value: description
                                    }
                                };
                                if (peripheralId) {
                                    var lowerCasedPeripheralId = peripheralId.toLowerCase();
                                    suggestions[lowerCasedPeripheralId] = {
                                        label: peripheralId,
                                        value: {
                                            type: "string",
                                            value: lowerCasedPeripheralId
                                        }
                                    };
                                }
                            }
                        }
                    });
                }
            });
            // Convert the map to an array of SearchValue.
            return Object.keys(suggestions).map(function(k) {
                return suggestions[k];
            });
        };
        return _this;
    }
    var _proto = DevicesTopBar.prototype;
    _proto.render = function render() {
        var _props = this.props, search = _props.search, page = _props.page, pageSize = _props.pageSize, filteredPeripherals = _props.filteredPeripherals, handlePageChange = _props.handlePageChange, handleSearchChange = _props.handleSearchChange;
        var suggestions = this.generateSuggestions();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_top_bar/* default */.Z, {
            search: search,
            suggestions: suggestions,
            page: page,
            pageSize: pageSize,
            handlePageChange: handlePageChange,
            handleSearchChange: handleSearchChange,
            totalCount: filteredPeripherals.length
        });
    };
    return DevicesTopBar;
}(react.Component);
/* harmony default export */ var sensors_overview_top_bar = (DevicesTopBar);

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-player@2.12.0_react@17.0.2/node_modules/react-player/lazy/index.js
var lazy = __webpack_require__(88345);
;// CONCATENATED MODULE: ./views/sensors/sensor-card-video.tsx






















var styles = function(theme) {
    return {
        card: {
            minHeight: "100%",
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        actions: {
            paddingLeft: theme.spacing(),
            paddingBottom: theme.spacing(),
            display: "flex",
            justifyContent: "space-around"
        },
        button: {
            margin: theme.spacing()
        },
        nodeIcon: {
            height: 25,
            width: 25,
            marginRight: theme.spacing(),
            marginBottom: -theme.spacing()
        },
        menu: {},
        menuItemStyles: {
            padding: theme.spacing(),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        menuItemIcon: {
            minWidth: theme.spacing(4)
        }
    };
};
var DeviceOverviewVideoCard = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DeviceOverviewVideoCard, _Component);
    var _super = (0,_create_super/* default */.Z)(DeviceOverviewVideoCard);
    function DeviceOverviewVideoCard() {
        (0,_class_call_check/* default */.Z)(this, DeviceOverviewVideoCard);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            isHover: false,
            settingsDialogOpen: false,
            menuAnchorEl: null
        };
        _this.handleDialogChange = function(open) {
            _this.setState({
                settingsDialogOpen: open
            });
        };
        _this.handleMenuClose = function() {
            _this.setState({
                menuAnchorEl: null
            });
        };
        _this.preventContextMenu = function(e) {
            return e.preventDefault();
        };
        _this.handleMenuClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                menuAnchorEl: e.currentTarget
            });
        };
        _this.closeMenu = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.handleMenuClose();
        };
        _this.openSettingsDialog = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                menuAnchorEl: null,
                settingsDialogOpen: true
            });
        };
        return _this;
    }
    var _proto = DeviceOverviewVideoCard.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, device = _props.device, camera = _props.camera, t = _props.t;
        var _state = this.state, settingsDialogOpen = _state.settingsDialogOpen, menuAnchorEl = _state.menuAnchorEl;
        var openMenu = Boolean(menuAnchorEl);
        var uuid = device.uuid;
        var index = camera.index, name = camera.name, description = camera.description;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    className: classes.card,
                    elevation: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_link/* ImperceptibleLink */.ah, {
                        href: {
                            pathname: "/sensor",
                            query: {
                                peripheralId: "".concat(uuid, "-").concat(index),
                                tab: "camera"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    padding: "16px 24px 16px 24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            flex: "1 1 auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: "textSecondary",
                                                variant: "body2",
                                                children: description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            flex: "0 0 auto",
                                            marginLeft: "15px",
                                            width: "40px",
                                            height: "40px",
                                            paddingTop: "3px"
                                        },
                                        children:  false ? /*#__PURE__*/ 0 : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            flex: "0 0 auto",
                                            marginLeft: "5px",
                                            width: "40px",
                                            height: "40px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                className: classes.menu,
                                                "aria-label": "More",
                                                "aria-owns": openMenu ? "long-menu" : undefined,
                                                "aria-haspopup": "true",
                                                onClick: this.handleMenuClick,
                                                size: "large",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                                id: "long-menu",
                                                anchorEl: menuAnchorEl,
                                                open: openMenu,
                                                onClose: this.closeMenu,
                                                PaperProps: {
                                                    style: {}
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                    selected: false,
                                                    onClick: this.openSettingsDialog,
                                                    className: classes.menuItemStyles,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                            className: classes.menuItemIcon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsSharp/* default */.Z, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "inherit",
                                                            noWrap: true,
                                                            children: t([
                                                                "sensor:sensorSettings"
                                                            ], {
                                                                defaultValue: "Sensor settings"
                                                            })
                                                        })
                                                    ]
                                                }, "sensorSettings")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                style: {
                                    padding: "0px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        height: "215px",
                                        overflow: "hidden",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: camera.streamURL !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy/* default */.Z, {
                                        url: camera.streamURL,
                                        width: "100%",
                                        height: "auto",
                                        controls: false,
                                        onContextMenu: this.preventContextMenu,
                                        config: {
                                            file: {
                                                hlsOptions: {
                                                    autoStartLoad: true,
                                                    maxMaxBufferLength: 0.1
                                                }
                                            }
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        display: "block",
                                        children: t([
                                            "device:cameraIsOffline"
                                        ], {
                                            defaultValue: "Camera appears to be offline"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sensor_settings_dialog/* default */.Z, {
                    handleDialogChange: this.handleDialogChange,
                    dialogOpen: settingsDialogOpen,
                    peripheralId: camera.peripheralId
                })
            ]
        });
    };
    return DeviceOverviewVideoCard;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "device"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var sensor_card_video = (enhance(DeviceOverviewVideoCard));

;// CONCATENATED MODULE: ./views/sensors/overview-page.tsx
































// We extract the query, so that we can maintain a state for each Apollo query.
var InternalDeviceCard = function(param) {
    var peripheral = param.peripheral, deviceVariables = param.deviceVariables;
    var ref = (0,react.useState)(""), dataHash = ref[0], setDataHash = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
        ssr: false,
        partialRefetch: true,
        context: {
            batchFour: true
        },
        errorPolicy: "all" // Necessary for returning partial data.
        ,
        query: (device_minimum_data_default()),
        fetchPolicy: "cache-and-network",
        onCompleted: (0,hash/* updateDataHash */.G)(setDataHash),
        variables: deviceVariables,
        children: function(param) {
            var data = param.data, loading = param.loading;
            var ref;
            var ref1;
            var sensor = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.device) === null || ref === void 0 ? void 0 : ref.peripheral) !== null && ref1 !== void 0 ? ref1 : peripheral;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(device_overview_card, {
                device: peripheral.parentDevice,
                dataHash: dataHash,
                sensor: sensor,
                loading: loading,
                refetchQueries: [
                    {
                        query: (device_minimum_data_default()),
                        variables: deviceVariables
                    }, 
                ]
            }, "".concat(peripheral.parentDevice.uuid).concat(sensor.index));
        }
    }, "".concat(peripheral.parentDevice.uuid).concat(peripheral.index));
};
var PeripheralCards = function(param) {
    var filteredPeripherals = param.filteredPeripherals, currentPage = param.currentPage, pageSize = param.pageSize, timeAtLoad = param.timeAtLoad;
    var mostRecentMinute = Math.round(timeAtLoad.getTime() / (1000 * 60)) * 1000 * 60;
    var currentPagePeripherals = (0,_to_consumable_array/* default */.Z)(filteredPeripherals).slice(currentPage * pageSize, currentPage * pageSize + pageSize);
    /* Note:
   *  The below piece of code deliberately launches a request per sensor card in view.
   *  This is done in order to better utilize the client side cache from already loaded devices,
   *  while filtering and changing page. Another pro of doing it as potentially 6 requests,
   *  is that the loading of the cards are asynchronous, which gives a great user experience.
   *  The alternative was to make a single request for all 6 devices, loosing the above pros.
   */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: currentPagePeripherals.map(function(peripheral) {
            if (peripheral.peripheralType === schema/* PeripheralType.SENSOR */.Ti.SENSOR) {
                var deviceVariables = {
                    uuid: peripheral.parentDevice.uuid,
                    index: peripheral.index,
                    time: [
                        {
                            from: new Date(mostRecentMinute - 8..hours).toISOString(),
                            to: new Date(mostRecentMinute).toISOString()
                        }, 
                    ],
                    points: constants/* SAMPLE_POINTS */.fd
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalDeviceCard, {
                    peripheral: peripheral,
                    deviceVariables: deviceVariables
                }, peripheral._id || Math.random());
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sensor_card_video, {
                    device: peripheral.parentDevice,
                    camera: peripheral
                }, "".concat(peripheral.parentDevice.uuid).concat(peripheral.index));
            }
        })
    });
};
var overview_page_styles = function(theme) {
    return {
        fillHeight: {
            height: "100%"
        },
        flexContainer: {
            display: "flex"
        }
    };
};
var DeviceCardPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DeviceCardPage, _Component);
    var _super = (0,_create_super/* default */.Z)(DeviceCardPage);
    function DeviceCardPage(props) {
        (0,_class_call_check/* default */.Z)(this, DeviceCardPage);
        var _this;
        var ref, ref1;
        _this = _super.call(this, props);
        _this.state = {
            search: [],
            page: 0,
            compareDevices: [],
            flattenedPeripherals: []
        };
        _this.pageSize = constants/* PAGE_SIZE */.IV;
        _this.filterPeripherals = function(devices) {
            var flattenedPeripherals = _this.state.flattenedPeripherals;
            // This covers hot reloading, which won't call onCompleted again, and clears state.
            if (!flattenedPeripherals || flattenedPeripherals.length === 0) {
                flattenedPeripherals = devices.reduce(function(prev, cur) {
                    var _prev;
                    (_prev = prev).push.apply(_prev, (0,_to_consumable_array/* default */.Z)(((cur === null || cur === void 0 ? void 0 : cur.peripherals) || []).filter(helper_types/* isTruthy */.f).map(function(peripheral) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, peripheral), {
                            parentDevice: cur
                        });
                    })));
                    return prev;
                }, []);
            }
            var filteredPeripherals = flattenedPeripherals.filter(function(peripheral) {
                // If we haven't started searching yet, include all results.
                if (!_this.state.search.length) {
                    return true;
                }
                // Filter out both results and remaining suggestions, based on the search filter.
                var foundInSearch = false;
                _this.state.search.map(function(searchTerm) {
                    if (searchTerm && searchTerm.value && searchTerm.value.value) {
                        var ref;
                        foundInSearch = peripheral.name.toLowerCase().includes(searchTerm.value.value.toLowerCase()) || peripheral.description.toLowerCase().includes(searchTerm.value.value.toLowerCase()) || ((ref = peripheral.peripheralId) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(searchTerm.value.value.toLowerCase()));
                    }
                });
                return foundInSearch;
            });
            // Sort the devices alphabetically, to always give a consistent view to the user.
            return filteredPeripherals.sort(function(left, right) {
                return left.name.localeCompare(right.name);
            }).sort(function(peripheral) {
                return +(peripheral.peripheralType === schema/* PeripheralType.CAMERA */.Ti.CAMERA);
            });
        };
        _this.getWrappedMessage = function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: _this.props.t([
                            "shared:accessToNoDevices"
                        ], {
                            defaultValue: "You do not have access to any sensors yet!"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: _this.props.t([
                            "shared:contactLocalAdministrator"
                        ], {
                            defaultValue: "Please contact your local administrator for help."
                        })
                    })
                ]
            });
        };
        _this.finishedQueringDevice = function(data) {
            var ref;
            var devices = ((ref = data === null || data === void 0 ? void 0 : data.devices) !== null && ref !== void 0 ? ref : []).filter(helper_types/* isTruthy */.f);
            var flattenedPeripherals = _this.state.flattenedPeripherals;
            // Flatten the devices only when we get new data.
            if (devices.length !== 0 && (!(flattenedPeripherals === null || flattenedPeripherals === void 0 ? void 0 : flattenedPeripherals.length) || !isEqual_default()(devices, _this.state.compareDevices))) {
                var updatedFlattenedPeripherals = devices.filter(function(device) {
                    return device;
                }).reduce(function(prev, cur) {
                    var _prev;
                    (_prev = prev).push.apply(_prev, (0,_to_consumable_array/* default */.Z)((cur.peripherals || []).filter(helper_types/* isTruthy */.f).map(function(peripheral) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, peripheral), {
                            parentDevice: cur
                        });
                    })));
                    return prev;
                }, []);
                _this.setState({
                    flattenedPeripherals: updatedFlattenedPeripherals,
                    compareDevices: devices
                });
            }
        };
        _this.updateSessionStorage = function(newRoute) {
            // Update the session (tab specific) storage entry for navigation.
            if (typeof Storage !== "undefined") {
                window.sessionStorage.setItem(constants/* SESSION_STORAGE_DEVICES_NAVIGATION_OVERVIEW_SEARCH_STATE_KEY */.Vi, JSON.stringify({
                    route: {
                        pathname: newRoute.pathname,
                        query: newRoute.query
                    }
                }));
            }
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePageChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this1.props.router, pathname = _router.pathname, query = _router.query;
                            _this1.setState({
                                page: page
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                page: page
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this1.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(page) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleSearchChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(val) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this2.props.router, pathname = _router.pathname, query = _router.query;
                            _this2.setState({
                                search: val,
                                page: 0
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                search: JSON.stringify(val),
                                page: 0
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this2.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }();
        if (props.router.query.search) {
            try {
                var searchQuery = Array.isArray(props.router.query.search) ? props.router.query.search[0] : props.router.query.search;
                _this.state.search = JSON.parse(searchQuery);
            } catch (routerError) {
                console.error(routerError);
            }
        }
        if (props.router.query.page) {
            try {
                var pageQuery = Array.isArray(props.router.query.page) ? props.router.query.page[0] : props.router.query.page;
                _this.state.page = parseInt(pageQuery, 10);
            } catch (routerError1) {
                console.error(routerError1);
            }
        }
        var ref2, ref3;
        _this.updateSessionStorage({
            pathname: (ref2 = props === null || props === void 0 ? void 0 : (ref = props.router) === null || ref === void 0 ? void 0 : ref.pathname) !== null && ref2 !== void 0 ? ref2 : "/sensors",
            query: (ref3 = props === null || props === void 0 ? void 0 : (ref1 = props.router) === null || ref1 === void 0 ? void 0 : ref1.query) !== null && ref3 !== void 0 ? ref3 : {}
        });
        return _this;
    }
    var _proto = DeviceCardPage.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, width = _props.width, timeAtLoad = _props.timeAtLoad;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
            query: (devices_simple_default()),
            partialRefetch: true,
            onCompleted: this.finishedQueringDevice,
            ssr: false,
            fetchPolicy: "cache-and-network",
            errorPolicy: "all" // Necessary for returning partial data.
            ,
            children: function(param) {
                var loading = param.loading, error = param.error, data = param.data;
                var ref;
                var devices = (ref = data === null || data === void 0 ? void 0 : data.devices) !== null && ref !== void 0 ? ref : [];
                var wrappedMessage = !loading && !error && !devices.length ? _this.getWrappedMessage() : undefined;
                // We only short-circuit the render if the query is loading or returned only an error (i.e. not an error + data).
                if (loading && !data || error && !data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sensors_overview_top_bar, {
                                search: _this.state.search,
                                page: _this.state.page,
                                pageSize: _this.pageSize,
                                filteredPeripherals: [],
                                handlePageChange: _this.handlePageChange,
                                handleSearchChange: _this.handleSearchChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                                loading: loading,
                                error: error,
                                wrappedMessage: wrappedMessage
                            })
                        ]
                    });
                }
                var filteredPeripherals = _this.filterPeripherals(devices.filter(helper_types/* isTruthy */.f));
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sensors_overview_top_bar, {
                            search: _this.state.search,
                            page: _this.state.page,
                            pageSize: _this.pageSize,
                            filteredPeripherals: filteredPeripherals,
                            handlePageChange: _this.handlePageChange,
                            handleSearchChange: _this.handleSearchChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                            loading: loading,
                            error: error,
                            data: data,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 1,
                                alignItems: "stretch",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PeripheralCards, {
                                        filteredPeripherals: filteredPeripherals,
                                        currentPage: _this.state.page,
                                        pageSize: _this.pageSize,
                                        timeAtLoad: timeAtLoad
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                        mdUp: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                                totalPages: Math.ceil(filteredPeripherals.length / _this.pageSize),
                                                currentPage: _this.state.page,
                                                onCurrentPageChange: _this.handlePageChange,
                                                totalCount: filteredPeripherals.length,
                                                pageSize: _this.pageSize
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        });
    };
    return DeviceCardPage;
}(react.Component);
var overview_page_enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "device"
]), router.withRouter, (0,with_styles/* withStyles */.D)(overview_page_styles), (0,with_width/* withWidth */.of)());
/* harmony default export */ var overview_page = (overview_page_enhance(DeviceCardPage));

;// CONCATENATED MODULE: ./pages/sensors/index.tsx



var Sensors = function() {
    var ref = (0,react.useState)(Date.now()), fetchTime = ref[0], setFetchTime = ref[1];
    (0,react.useEffect)(function() {
        var handle = setTimeout(function() {
            setFetchTime(Date.now());
        }, 5..minutes);
        return function() {
            return clearTimeout(handle);
        };
    }, [
        fetchTime
    ]);
    var timeAtLoad = (0,react.useMemo)(function() {
        return new Date(fetchTime);
    }, [
        fetchTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_page, {
        timeAtLoad: timeAtLoad
    });
};
var __N_SSG = true;
/* harmony default export */ var sensors = (Sensors);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7318,2742,7164,6355,9238,5936,3964,6620,9670,5377,9071,4629,7179,8563,3417,8850,255,2265,2500,5318,6022,8345,3616,9921,9225,3732,9774,2888,179], function() { return __webpack_exec__(99731); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);